import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from '@mui/material';
import CustomTable from './Table';

const TrainerListResults = ({
  trainers = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={trainers}
        dataKeysSequence={[
          'profile_pic',
          'name',
          'email',
          'phone',
          'experience',
          'actions'
        ]}
        headers={['Profile Pic', 'Name', 'Email', 'Phone', 'Experience' ,'Actions']}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

TrainerListResults.propTypes = {
  trainers: PropTypes.array.isRequired
};

export default TrainerListResults;
